import { ReactNode } from 'react';
import { StyleSheet, Text, TextInput, View } from 'react-native';
import mixins from '@streamster/shared/app/styles';

const styles = StyleSheet.create({
  input: {
    backgroundColor: mixins().color.darker,
    borderBottomWidth: 2,
    borderColor: mixins().color.grayDarkest,
    margin: 2,
    paddingVertical: 10,
    paddingHorizontal: 20,
    flexGrow: 1,
    color: mixins().color.white,
  },
  inputWide: {
    flexGrow: 1,
    minWidth: 400,
  },
  inputMultiline: {
    minHeight: 200,
    textAlignVertical: 'top',
  },
  inputError: {
    borderColor: mixins().color.redDark,
  },
  inputGroup: {
    flexGrow: 1,
  },
  row: {
    flexDirection: 'row',
  },
  rowWithMargin: {
    marginBottom: mixins().indent.i5,
    flexDirection: 'row',
  },
  label: {
    lineHeight: 40,
    width: 130,
    color: mixins().color.grey,
  },
  labelSmall: {
    width: 90,
  },
  tip: {
    fontSize: 12,
    color: mixins().color.grey,
  },
  tipError: {
    fontSize: 12,
    color: mixins().color.redDark,
  },
});

export const inputWithLabelFieldStyles = StyleSheet.create({
  select: {
    backgroundColor: mixins().color.darker,
    borderColor: mixins().color.grayDarkest,
    borderWidth: 2,
    borderBottomStyle: 'solid',
    height: 40,
    paddingHorizontal: 20,
    width: '100%',
  },
});

interface Props {
  onChange?: (text: string) => void;
  name: string;
  tip?: string;
  tipError?: boolean;
  value?: string;
  withMargin?: boolean;
  wide?: boolean;
  secure?: boolean;
  children?: ReactNode;
  multiline?: boolean;
  placeholder?: string;
}

export const InputWithLabel = ({
  withMargin,
  onChange,
  name,
  tip,
  tipError,
  value,
  wide,
  secure,
  children,
  multiline,
  placeholder,
}: Props) => {
  return (
    <View style={withMargin ? styles.rowWithMargin : styles.row}>
      <Text style={styles.label}>{name}</Text>
      <View style={styles.inputGroup}>
        {children ? (
          children
        ) : (
          <TextInput
            maxLength={multiline ? 1024 : undefined}
            style={[styles.input, wide && styles.inputWide, multiline && styles.inputMultiline]}
            value={value}
            onChangeText={onChange}
            secureTextEntry={secure}
            placeholder={placeholder}
            multiline={multiline}
          />
        )}
        {tip && <Text style={tipError ? styles.tipError : styles.tip}>{tip}</Text>}
      </View>
    </View>
  );
};
